import { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, StoreState } from "../../redux/store";
import { getUserSettings } from "../../redux/users/usersSlice";
import { authService } from "../../services";

const useFetchUserSettings = (isPublic: boolean = false) => {
  const dispatch = useDispatch<AppDispatch>();
  const { loading, error, currentUserSettings } = useSelector((state: StoreState) => state.users);
  const shouldFetch = useRef(true);
  const isAuthenticated = authService.isAuthenticated();

  useEffect(() => {
    if (!currentUserSettings && shouldFetch.current && !isPublic && isAuthenticated) {
      shouldFetch.current = false;
      dispatch(getUserSettings());
    }
  }, [currentUserSettings, dispatch, loading, isPublic, isAuthenticated]);

  return { loading, currentUserSettings, error };
};

export default useFetchUserSettings;
